import { Link } from 'react-router-dom';
function Footer() {
  return (
    <div className="footer">
        <div className='container'>
            <div className='top'>
                <Link to="/" className='logo'>KNO1996</Link>
                <Link to="/company" className='text'>회사소개</Link>
                <Link to="/business" className='text'>비즈니스</Link>
            </div>
            <div className='info'>
              <div className='item'>경기 용인시 처인구 모현읍 오산리 343-32(경기 용인시 처인구 모현읍 오산로 186-2)</div>
              <div className='item'>TEL. 031-338-5542</div>
              <div className='item'>FAX. 031-338-5541</div>
            </div>
            <div className='copyright'>
                COPYRIGHT © 2024 KNO1996. ALL RIGHTS RESERVED.
            </div>
        </div>
    </div>
  );
}
export default Footer;